module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.0e305249.svg";